import * as React from "react";
import { Modal, Button, Divider } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import { DateService } from "../../../service/DateService";
import Text from "antd/lib/typography/Text";
export interface State {}

export interface Props {
  requestsDetailsDialogVisible?: boolean;
  hideRequestsDetailsDialog: any;
  translate: TTranslate;
  rowData: any;
}

function formatDate(date: Date) {
  return DateService().formatDate(date);
}

export default class RequestDetailsDialog extends React.Component<
  Props,
  State
> {
  render() {
    const {
      translate,
      rowData,
      requestsDetailsDialogVisible,
      hideRequestsDetailsDialog
    } = this.props;

    return (
      <div>
        <Modal
          title={rowData && rowData.name}
          visible={requestsDetailsDialogVisible}
          onCancel={hideRequestsDetailsDialog}
          maskClosable={false}
          footer={[
            <Button key="back" onClick={hideRequestsDetailsDialog}>
              {translate("modal_functions.action_modal.cancel")}
            </Button>
          ]}
        >
          {rowData && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ marginBottom: 7 }}>
                <Text strong>
                  {translate("applicantRequest_page.validFrom")}:{" "}
                </Text>
                {formatDate(rowData.validFrom)}
              </span>
              {rowData.validTo && (
                <span style={{ marginBottom: 7 }}>
                  <Text strong>
                    {translate("applicantRequest_page.validTo")}:{" "}
                  </Text>
                  {formatDate(rowData.validTo)}
                </span>
              )}
              <span style={{ marginBottom: 7 }}>
                <Text strong>
                  {translate("applicantRequest_page.reporting_period_name")}:{" "}
                </Text>
                {rowData.reportingPeriodName}
              </span>
              <span style={{ marginBottom: 7 }}>
                <Text strong>
                  {translate("applicantRequest_page.request_type_name")}:{" "}
                </Text>
                {rowData.requestTypeName}
              </span>
            </div>
          )}
          {rowData?.content && (
            <div>
              <Divider style={{ marginTop: 10, marginBottom: 10 }} />
              {rowData.content.toLowerCase().includes("<html>") &&
              rowData.content.toLowerCase().includes("</html>") ? (
                <span dangerouslySetInnerHTML={{ __html: rowData.content }} />
              ) : (
                <span style={{ whiteSpace: "pre-wrap" }}>
                  {rowData.content}
                </span>
              )}
            </div>
          )}
        </Modal>
      </div>
    );
  }
}
